import { Component, Inject, OnInit, Renderer2, NgZone, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { environment } from 'src/environments/environment';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { AuthService } from 'src/app/_services/auth.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-navigation-security',
	templateUrl: './navigation-security.component.html',
	styleUrls: ['./navigation-security.component.css'],
})

export class NavigationSecurityComponent implements OnInit {

	sc = JSON.parse(localStorage.getItem(environment.SchoolInFo));
	cu = JSON.parse(localStorage.getItem(environment.currentUser));
	public config: PerfectScrollbarConfigInterface = { wheelPropagation: true };

	@ViewChild(PerfectScrollbarComponent, { static: false }) componentRef?: PerfectScrollbarComponent;
	@ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;

	constructor(
		public authService: AuthService,
		private router: Router
	) { }

	ngOnInit() {

	}

	logout() {
		if (localStorage.getItem('currentUser')) {
			this.authService.doLogoutSecurity().then(res => {
				this.router.navigate(['/login']);
			}, err => {
				console.log(err);
			});
		}
	}

}
